import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfHelpModalComponent } from './perf-help-modal.component';
import { ButtonModule } from '@xref/xref-lib';


@NgModule({
  declarations: [PerfHelpModalComponent],
  imports: [
    CommonModule,
    ButtonModule
  ]
})
export class PerfHelpModalModule { }
